import styled from "@yb/styled-px2rem";

const Wrap = styled.div`
	padding-bottom: 40px;
`;

const HeaderWrap = styled.div`
	position: relative;
	display: flex;
	height: 60px;
	border-bottom: 1px solid var(--line-color);
	justify-content: center;
	align-items: center;

	h3 {
		font-size: 21px;
		letter-spacing: -0.05em;
		color: var(--emp-color);
		overflow: hidden;
		font-weight: bold;
		text-overflow: ellipsis;
		white-space: normal;
		word-wrap: break-word;
		word-break: break-all;
		line-clamp: 1;
	}

	button {
		position: absolute;
		top: 50%;
		right: 15px;
		transform: translateY(-50%);
	}
`;

const AccountNotice = styled.div`
	margin: 40px 15px 0;
	line-height: 24px;
	color: var(--default-color);
	font-size: 13px;
`;

const InfoList = styled.ul`
	display: flex;
	padding: 30px 15px;
	margin: 30px 15px 0;
	border: 1px solid var(--line-color);
	box-sizing: border-box;
	gap: 5px;
	flex-wrap: wrap;
	flex-direction: column;

	li {
		position: relative;
		display: flex;
		padding-left: 12px;
		line-height: 24px;

		&:before {
			position: absolute;
			left: 0;
			top: 10px;
			width: 3px;
			height: 3px;
			border-radius: 50%;
			background-color: var(--bl-color);
			content: "";
		}

		> span {
			margin-right: 18px;

			&:last-child {
				margin-right: 0;
			}

			&:first-child {
				width: 60px;
				color: var(--emp-color);
				flex-shrink: 0;
			}
		}
	}
`;

export {Wrap, HeaderWrap, InfoList, AccountNotice};
